import { Link } from "react-router";
import { cn } from "@/lib/cn";

type Props = {
  patientId: string | null | undefined;
  patientName: string;
  className?: string;
  /** Depois de abrir a ficha — ex.: fechar o dialog onde o link está. */
  onAbrir?: () => void;
  /** Outro endereço pra ficha (a de outra clínica, só leitura). */
  href?: string;
};

/**
 * Nome do paciente na lista de pedidos, clicável quando existe ficha.
 *
 * A linha inteira já abre o pedido, então o clique aqui para a propagação — senão abrir a ficha
 * abriria o pedido junto. Pedido sem `patientId` (paciente digitado à mão, ou apagado depois) fica
 * como texto: link que leva a lugar nenhum é pior que nenhum link.
 */
export function LinkDoPaciente({ patientId, patientName, className, onAbrir, href }: Props) {
  if (!patientId) return <span className={className}>{patientName}</span>;
  return (
    <Link
      to={href ?? `/pacientes/${patientId}`}
      onClick={(e) => {
        e.stopPropagation();
        onAbrir?.();
      }}
      title={`Abrir a ficha de ${patientName}`}
      className={cn(
        "underline decoration-zinc-300 decoration-1 underline-offset-2 transition-colors hover:text-brand-700 hover:decoration-brand-400 dark:decoration-border dark:hover:text-primary",
        className,
      )}
    >
      {patientName}
    </Link>
  );
}
